module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-25.06214afb.jpg";